// React/finance-app/src/features/tt-insights/tabs/BalancesAllTab.jsx
import React from 'react';
import { money } from '../utils';
import ExportButton from '../ExportButton';

const BalancesAllTab = ({
  loading,
  fetchBalances,
  balances,
  balancesMeta,
  balancesLimit,
  setBalancesLimit,
}) => (
  <div className="card">
    <div className="card-header d-flex flex-wrap gap-2 justify-content-between align-items-center">
      <span>Available Balances — All Users</span>
      <div className="d-flex gap-2 align-items-center">
        <label className="me-1 small">Show first</label>
        <select
          className="form-select form-select-sm"
          style={{ width: 110 }}
          value={balancesLimit}
          onChange={(e) => setBalancesLimit(Number(e.target.value))}
        >
          <option value={100}>100</option>
          <option value={200}>200</option>
          <option value={500}>500</option>
          <option value={1000}>1000</option>
          <option value={999999}>All</option>
        </select>
        <button className="btn btn-primary btn-sm" onClick={fetchBalances} disabled={loading}>
          {loading ? 'Loading…' : 'Refresh'}
        </button>
        <ExportButton
          disabled={loading || (balances?.length ?? 0) === 0}
          filenameBase="available-balances"
          sheetName="Balances"
          columns={[
            { key: "user_code", header: "User" },
            { key: "paid_referral", header: "Paid Referral", render: v => money(v) },
            { key: "paid_trust", header: "Paid Trust", render: v => money(v) },
            { key: "paid_deposit", header: "Paid Deposit", render: v => money(v) },
            { key: "total_paid", header: "Total Paid", render: v => money(v) },
            { key: "charges_and_credits", header: "Charges & Credits", render: v => money(v) },
            { key: "withdrawn_filtered", header: "Withdrawn", render: v => money(v) },
            { key: "expired_deduction", header: "Expired (Trust)", render: v => money(v) },
            { key: "expired_referral_deduction", header: "Expired (Referral)", render: v => money(v) },
            { key: "available_balance", header: "Available", render: (v, r) => r.formatted_balance ?? money(v) },
            { key: "balance_status", header: "Status" },
          ]}
          rows={(balances ?? []).slice(0, balancesLimit)}
        />
      </div>
    </div>
    <div className="card-body table-responsive">
      {balancesMeta?.total_records !== undefined && (
        <div className="text-muted mb-2">Total records: {balancesMeta.total_records}</div>
      )}
      <table className="table table-sm table-bordered table-striped">
        <thead>
          <tr>
            <th>User</th>
            <th>Paid Referral</th>
            <th>Paid Trust</th>
            <th>Paid Deposit</th>
            <th>Total Paid</th>
            <th>Charges & Credits</th>
            <th>Withdrawn</th>
            <th>Expired (Trust)</th>
            <th>Expired (Referral)</th>
            <th>Available</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {(balances ?? []).slice(0, balancesLimit).map((row, idx) => (
            <tr key={idx}>
              <td>{row.user_code}</td>
              <td title={String(row.paid_referral)}>{money(row.paid_referral)}</td>
              <td title={String(row.paid_trust)}>{money(row.paid_trust)}</td>
              <td title={String(row.paid_deposit)}>{money(row.paid_deposit)}</td>
              <td title={String(row.total_paid)}>{money(row.total_paid)}</td>
              <td title={String(row.charges_and_credits)}>{money(row.charges_and_credits)}</td>
              <td title={String(row.withdrawn_filtered)}>{money(row.withdrawn_filtered)}</td>
              <td title={String(row.expired_deduction)}>{money(row.expired_deduction)}</td>
              <td title={String(row.expired_referral_deduction)}>{money(row.expired_referral_deduction)}</td>
              <td title={String(row.available_balance)}>{row.formatted_balance ?? money(row.available_balance)}</td>
              <td>{row.balance_status}</td>
            </tr>
          ))}
          {(balances ?? []).length === 0 && (
            <tr><td colSpan="11" className="text-center text-muted">No data</td></tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

export default BalancesAllTab;
